import { render, staticRenderFns } from "./MarketingPanel.vue?vue&type=template&id=288660e0&scoped=true"
import script from "./MarketingPanel.vue?vue&type=script&lang=js"
export * from "./MarketingPanel.vue?vue&type=script&lang=js"
import style0 from "./MarketingPanel.vue?vue&type=style&index=0&id=288660e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288660e0",
  null
  
)

export default component.exports